const TOKEN_KEY = 'apiToken'
const SESSION_KEY = 'sessionToken'

const authUser = {
  clearToken() {
      sessionStorage.removeItem(TOKEN_KEY)
  },

  setToken(token) {
      sessionStorage.setItem(TOKEN_KEY, token)
  },

  getToken() {
    return sessionStorage.getItem(TOKEN_KEY)
  },

  clearSessionToken() {
    sessionStorage.removeItem(SESSION_KEY)
  },

  getSessionToken() {
    return sessionStorage.getItem(SESSION_KEY)
  },

  setSessionToken(sessionToken) {
    sessionStorage.setItem(SESSION_KEY, sessionToken)
  }
}


export default authUser